import * as vehiclesInventory from './vehiclesInventory';

const reducers = {
  ...vehiclesInventory,
};

export default reducers;
